export default {"src":"/_next/static/media/GROUP.d6a6a8ec.svg","height":58,"width":60,"blurWidth":0,"blurHeight":0};